<template>
  <div class="d-flex align-center w-100 modern-add-article pa-1">
    <div class="flex-grow-1">
      <article-complete v-model="selected" :disabled="disabled" class="modern-autocomplete" />
    </div>
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn 
          v-bind="attrs" 
          v-on="on"
          :disabled="disabled" 
          icon 
          color="primary" 
          class="ml-2 grey lighten-4 shadow-xs" 
          @click="show = true"
        >
          <v-icon >fas fa-table-list</v-icon>
        </v-btn>
      </template>
      <span>Explorar catálogo en tabla</span>
    </v-tooltip>

    <v-dialog v-model="show" max-width="1100" transition="dialog-bottom-transition" persistent>
      <v-card outlined class="modern-card overflow-hidden">
        <v-sheet color="primary" class="pa-6 d-flex align-center">
          <v-avatar size="44" color="white opacity-20" class="mr-4 shadow-sm">
            <v-icon color="white">fas fa-boxes-stacked</v-icon>
          </v-avatar>
          <div>
            <div class="caption white--text opacity-80 font-weight-black text-uppercase tracking-widest mb-1">Catálogo de Suministros</div>
            <div class="text-h5 white--text font-weight-black lh-1-2">Seleccionar Artículo</div>
          </div>
          <v-spacer></v-spacer>
          <v-btn icon color="white" large @click="show = false">
            <v-icon>fas fa-times</v-icon>
          </v-btn>
        </v-sheet>
        
        <v-card-text class="pa-0">
          <articles-table v-model="selected" @close="show = false" />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ArticleComplete from '@/components/stocks/ArticleComplete'
import ArticlesTable from '@/components/stocks/ArticlesTable'
export default {
  name: 'AddArticle',
  components: { ArticleComplete, ArticlesTable },
  props: ['disabled'],
  data() {
    return {
      show: false,
      selected: '',
    }
  },
  watch: {
    selected() {
      if (this.selected != '') {
        var selected = {}
        selected = Object.assign({}, selected, this.selected)
        this.$emit('add', selected)
        this.$emit('close')
        this.show = false // Cierro si se selecciona desde la tabla
        this.selected = '' // Reseteo para permitir re-selección
      }
    }
  }
}
</script>

<style scoped>
.modern-add-article {
  max-width: 100%;
}
.modern-card {
  border-radius: 12px !important;
}
.modern-autocomplete >>> .v-input__control {
  min-height: 40px !important;
}
.modern-autocomplete >>> .v-input__slot {
  border-radius: 8px !important;
  background-color: white !important;
}
.shadow-xs {
  box-shadow: 0 1px 2px rgba(0,0,0,0.05) !important;
}
.shadow-sm {
  box-shadow: 0 4px 12px rgba(0,0,0,0.1) !important;
}
.tracking-widest { letter-spacing: 2px; }
.lh-1-2 { line-height: 1.2; }
.w-100 { width: 100%; }
</style>